import styled from 'styled-components'
import { Drawer } from 'vaul'
import Typography, { FontWeights } from 'builder/styles/typography'
import Colors from 'builder/styles/colors'

export const Overlay = styled(Drawer.Overlay)`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 99999;
`

export const Content = styled(Drawer.Content)`
  background-color: ${Colors.White};
  display: flex;
  flex-direction: column;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  margin-top: 6rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
`

export const DrawerClose = styled(Drawer.Close)`
  position: absolute;
  top: 15px;
  right: 16px;
  border: none;
  padding: 0;
  cursor: pointer;
`

export const DrawerHeader = styled.div`
  padding: 16px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`

export const DrawerTitle = styled(Drawer.Title)`
  margin-bottom: 16px;
  ${Typography.Caption}
  ${FontWeights.Medium}
`

export const DrawerParagraph = styled.p`
  color: ${Colors.Neutral50};
`

export const Footer = styled.div`
  padding: 16px;
  border-top: 1px solid ${Colors.Neutral10};
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
`
